import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=48eef17d&scoped=true&"
import script from "./SsoCallback.vue?vue&type=script&lang=js&"
export * from "./SsoCallback.vue?vue&type=script&lang=js&"
import style0 from "./SsoCallback.vue?vue&type=style&index=0&id=48eef17d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eef17d",
  null
  
)

export default component.exports